import Body from './Body'
import './BaseLayout.style.less'
import Footer from './Footer'
import { memo, useEffect, useState } from 'react'

import SideBar from './SideBar'
import { Drawer, Grid, Layout } from 'antd'
import cx from 'classnames'
import { useLocation } from 'react-router-dom'
import { loadLocalizationData } from '@/services/localization.service'
import { MobileSidebarContext } from './MobileSidebarContext'
import { SideBarContent } from './SideBar'

function BaseLayout() {
  // const isProd = process.env.REACT_APP_ENV === 'pre-prod'
  const isProd = false

  const location = useLocation()
  const screens = Grid.useBreakpoint()
  // `useBreakpoint()` returns {} on the first render (breakpoints are measured in an
  // effect that runs after first paint), so `!screens.md` is momentarily `true` even on
  // desktop. For SUPPLIER users that hides the desktop sidebar and the "My Orders" menu
  // until antd settles, which surfaces intermittently in production under render churn.
  // Fall back to a synchronous media query (antd's `md` token is min-width: 768px) so the
  // first paint already reflects the real viewport.
  const isMobile = !(
    screens.md ?? window.matchMedia('(min-width: 768px)').matches
  )
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)

  useEffect(() => {
    loadLocalizationData()
  }, [location])

  useEffect(() => {
    setIsMobileSidebarOpen(false)
  }, [location.pathname, location.search])

  return (
    <MobileSidebarContext.Provider
      value={{
        isMobile,
        closeMobileSidebar: () => setIsMobileSidebarOpen(false),
        openMobileSidebar: () => setIsMobileSidebarOpen(true),
      }}
    >
      <>
        {isProd && (
          <div className="env-tag-container">
            <p>
              <strong>PRE-PRODUCTION</strong> for testing purpose only
            </p>
          </div>
        )}
        <Layout
          style={{ marginTop: isProd ? 44 : 0 }}
          hasSider={!isMobile}
          className={cx('layout-container', isProd && 'layout-force')}
        >
          {!isMobile && <SideBar />}
          <Layout className="site-layout">
            <Body />
            <Footer />
          </Layout>
        </Layout>
        <Drawer
          className="mobile-sidebar-drawer"
          placement="left"
          closable={false}
          onClose={() => setIsMobileSidebarOpen(false)}
          open={isMobile && isMobileSidebarOpen}
          width={320}
          bodyStyle={{ padding: 12 }}
          destroyOnClose
        >
          <div className="sidebar-shell mobile-sidebar-shell">
            <SideBarContent
              collapsed={false}
              showCollapseToggle={false}
              onNavigateComplete={() => setIsMobileSidebarOpen(false)}
            />
          </div>
        </Drawer>
      </>
    </MobileSidebarContext.Provider>
  )
}

export default memo(BaseLayout)
